import { formatPrice } from '@/utils/formatPrice'
import { Button, HStack, Text, useColorModeValue } from '@chakra-ui/react'
import { useTranslations } from 'next-intl'
import { useRouter } from 'next/router'

interface PayNowButtonProps {
  totalDue: number
  invoiceId: string[] | string | undefined
  isPaid: boolean
}

export const PayNowButton = ({
  totalDue,
  invoiceId,
  isPaid = false,
}: PayNowButtonProps) => {
  const t = useTranslations()
  const router = useRouter()
  const blackAlpha900 = useColorModeValue('blackAlpha.900', 'white')

  const handlePayNow = () => {
    router.push({
      pathname: '/dashboard/billing/pay-invoices/',
      query: { id: invoiceId },
    })
  }

  return (
    <>
      <HStack justify="space-between" w="100%" mb={5}>
        <Text fontSize="16px" color={blackAlpha900} fontWeight={700}>
          {isPaid 
            ? t('dashboard.billing.total-paid')
            : t('dashboard.billing.total-due')
          }
        </Text>
        <Text fontSize="16px" color={blackAlpha900} fontWeight={700}>
          {formatPrice(totalDue)}
        </Text>
      </HStack>
      {!isPaid && (
        <Button
          colorScheme="blue"
          backgroundColor="brand.600"
          color="white"
          width="100%"
          onClick={handlePayNow}
        >
          {t('dashboard.billing.pay-now')}
        </Button>
      )}
    </>
  )
}
